import api from "api/offer/offerPartnerRelationsApi";
import * as docPartnerApi from "features/document/edit/partners/api";
import * as types from "actions/actionTypes/offer/partnerRelations/index";
import * as eventTypes from "actions/eventTypes/offer/partnerRelations/index";
import { FROM_PARTNER_QUERY_FOUND } from "features/offer/edit/assets/asset/eventTypes";
import { showError } from "actions/actionCreators/snackbarActions";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "../httpActions";

export function loadDocumentPartnerRelations(documentId, siteId) {
  return async dispatch => {
    try {
      const documentPartnerRelations = await dispatch(
        sendHttpRequest(docPartnerApi.getDocumentPartnerRelations(documentId, siteId))
      );
      dispatch({
        type: types.LOAD_DOCUMENT_PARTNER_RELATIONS_SUCCEEDED,
        payload: { documentPartnerRelations }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPartnerRelationTypes() {
  return async dispatch => {
    try {
      const partnerRelationTypes = await dispatch(sendHttpRequest(api.getPartnerRelationTypes()));
      dispatch({
        type: types.LOAD_PARTNER_RELATION_TYPES_SUCCEEDED,
        payload: { partnerRelationTypes }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function saveDocumentPartnerRelation(partnerRelationId, documentId, siteId, item, callback = () => {}) {
  return async dispatch => {
    dispatch({
      type: types.SAVE_DOCUMENT_PARTNER_RELATION_STARTED
    });
    if (!partnerRelationId)
      dispatch(
        sendHttpCommandAndWaitForEvent(
          api.savePartnerRelation(partnerRelationId, documentId, siteId, item),
          "SavePartnerRelation",
          [eventTypes.PARTNER_RELATION_SAVED],
          false
        )
      );
    dispatch(
      sendHttpCommandAndWaitForEvent(
        docPartnerApi.saveDocumentPartnerRelation(partnerRelationId, documentId, siteId, item),
        "SavePartnerRelation",
        [eventTypes.DOCUMENT_PARTNER_RELATION_SAVED]
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: types.SAVE_DOCUMENT_PARTNER_RELATION_SUCCEEDED,
            payload: { item }
          });
          callback(event.eventBody.partnerRelationId);
        } else {
          dispatch({
            type: types.SAVE_DOCUMENT_PARTNER_RELATION_FAILED,
            payload: { item: item, error: event }
          });
          callback();
        }
      })
      .catch(error => {
        dispatch(showError(error.message, error.correlationId));
        dispatch({
          type: types.SAVE_DOCUMENT_PARTNER_RELATION_FAILED,
          payload: { item: item, error }
        });
        callback();
      });
  };
}

export function loadPartner(uniqueId) {
  return sendHttpRequest(api.getClient(uniqueId));
}

export function externalSearchForPartner(registrationCode) {
  return async dispatch => {
    const event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        api.externalSearchForPartner(registrationCode),
        "ExternalSearchForPartnerCommand",
        [FROM_PARTNER_QUERY_FOUND],
        false
      )
    );

    if (event.ok) return event.eventBody;
  };
}
